import apiClient from 'api/apiClient';

// eslint-disable-next-line import/prefer-default-export
export const getRiskCapitalDeals = () => apiClient.get('/v1/risk_capital/deals');
